import axios from 'axios';
export const ROOT = '/api/user-wallet/internal-transfer';
export class InternalTransferError extends Error { constructor(message, code) { super(message); this.code = code; } }
export const money = n => Number(n).toLocaleString('ko-KR');
export const positive = n => Number.isSafeInteger(n) && n > 0;
export function validatePolicy(p) {
    if (!p || typeof p.enabled !== 'boolean' || typeof p.accepting_requests !== 'boolean') throw new InternalTransferError('전송 정책을 확인하지 못했습니다. 다시 조회해주세요.');
    if (p.enabled && (p.scope !== 'SAME_DIRECT_AGENT' || p.fee !== 0 || typeof p.pin_required !== 'boolean' || typeof p.registration_required !== 'boolean'
        || typeof p.policy_version !== 'string' || !p.policy_version || typeof p.csrf_token !== 'string' || !p.csrf_token.trim()
        || !positive(p.once_limit) || !positive(p.daily_limit))) throw new InternalTransferError('지원하지 않거나 불완전한 전송 정책입니다. 신규 전송을 중단했습니다.');
    return p;
}
export const policySignature = p => JSON.stringify([p.policy_version,p.pin_required,p.registration_required,p.scope,p.fee,p.once_limit,p.daily_limit]);
export function isCompleted(response, request, list = false) {
    if (response?.code !== 1000) return false;
    const rows = list ? response.data?.requests : [response.data];
    if (!Array.isArray(rows)) return false;
    const matches = rows.filter(r => r?.request_id === request.request_id);
    if (matches.length !== 1) return false;
    const r = matches[0];
    return r.status === 'SUCCESS' && r.amount === request.amount && r.fee === 0 && r.recipient?.mid === request.recipient_mid
        && (!list || (r.result?.code === 1000 && r.result.data?.request_id === request.request_id && r.result.data?.status === 'SUCCESS'));
}
export function createInternalClient(base = process.env.REACT_APP_API || '') {
    let csrf = '';
    const call = async (method, path, body, params) => {
        if (method === 'post' && !csrf) throw new InternalTransferError('보안 토큰을 다시 조회해주세요.',4032);
        try {
            const r = await axios({method,url:base+path,withCredentials:true,timeout:15000,
                ...(params ? {params} : {}), ...(method === 'post' ? {data:body,headers:{'Content-Type':'application/json','X-CSRF-Token':csrf}} : {})});
            return r.data;
        } catch(e) { if (e.response?.data && typeof e.response.data.code === 'number') return e.response.data; throw new InternalTransferError('서버 응답을 받지 못했습니다.'); }
    };
    const data = r => {if(r?.code !== 1000) throw new InternalTransferError(r?.msg || '요청을 처리하지 못했습니다.',r?.code);return r.data;};
    const searchRecipients = async mid => {
        const d=data(await call('get',ROOT+'/recipient',null,{mid}));
        const rows=Array.isArray(d?.recipients)?d.recipients:(d?.recipient?[d.recipient]:null);
        if(d?.scope!=='SAME_DIRECT_AGENT'||d.fee!==0||!rows||
            rows.some(r=>typeof r?.mid!=='string'||!r.mid.trim()||typeof r.name!=='string'||!r.name.trim())||
            new Set(rows.map(r=>r.mid)).size!==rows.length||
            (d.has_more!==undefined&&typeof d.has_more!=='boolean')) throw new InternalTransferError('받는 가맹점 정보를 확인하지 못했습니다.');
        return {recipients:rows.map(({mid,name})=>({mid,name})),has_more:d.has_more===true};
    };
    return {
        async policy() {csrf='';const p=validatePolicy(data(await call('get',ROOT+'/policy')));csrf=p.csrf_token || '';return p;},
        searchRecipients,
        async recipient(mid) {
            const found=await searchRecipients(mid);
            const exact=found.recipients.find(r=>r.mid===mid);
            if(!exact)throw new InternalTransferError('선택한 가맹점을 다시 확인하지 못했습니다. 검색 후 다시 선택해주세요.');
            return exact;
        },
        async funds() {const d=data(await call('get','/api/user-wallet/balance'));const raw=d?.wallet?.available_balance;const n=Number(raw);if(raw==null||raw===''||typeof raw==='boolean'||!Number.isSafeInteger(n)||n<0)throw new InternalTransferError('사용 가능 잔액을 확인하지 못했습니다.');return n;},
        security:{async post(path,body) {return data(await call('post','/api/security'+path,body));}},
        send(request,authorization) {return call('post',ROOT,{recipient_mid:request.recipient_mid,amount:request.amount,request_id:request.request_id,...(authorization ? {authorization} : {})});},
        query(requestId) {return call('get',ROOT+'/requests',null,{request_id:requestId});},
        clear(){csrf='';},
    };
}
export const pendingKey = mid => mid ? `internal-transfer:${process.env.REACT_APP_API || window.location.origin}:${mid}` : null;
export function readPending(key) {
    if(!key) throw new Error('로그인 가맹점 정보를 확인하지 못했습니다.');
    const raw=localStorage.getItem(key);if(!raw)return null;
    const r=JSON.parse(raw);
    if(!r || !/^[\da-f]{8}-[\da-f]{4}-4[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i.test(r.request_id)||!positive(r.amount)||typeof r.recipient_mid!=='string'||!r.recipient_mid.trim()) throw new Error('저장된 전송 요청을 읽지 못했습니다. 관리자에게 요청 결과 확인을 요청해주세요.');
    return {request_id:r.request_id,recipient_mid:r.recipient_mid,amount:r.amount,name:typeof r.name==='string'?r.name:r.recipient_mid};
}
export function writePending(key,r) {
    localStorage.setItem(key,JSON.stringify({request_id:r.request_id,recipient_mid:r.recipient_mid,amount:r.amount,name:r.name}));
}
